module.exports = __webpack_public_path__ + "img/u_edit-alt.fc658c40.svg";